/* SOLE scroll-reveal — gently fades below-the-fold content up as it enters view.
   SAFETY (no a11y / no perf regression):
   - Runs ONLY when <html> has .sole-reveal-ready, which the inline head guard adds solely when
     IntersectionObserver is supported AND the visitor has NOT requested reduced motion. If this
     script never runs (JS off/failed, old browser, reduced-motion, setting off), NOTHING is ever
     hidden — content stays fully visible. The hiding is applied by JS adding [data-reveal], so a
     no-JS render is untouched.
   - Above-the-fold / already-visible elements are revealed immediately (never hidden), protecting LCP.
   - opacity + transform only (GPU-friendly, no layout/CLS). Fires once, then unobserves. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('sole-reveal-ready')) return;

  // Opt-in via [data-reveal] anywhere, plus the PDP's below-the-fold content bands by default.
  // #pdp7-reviews is deliberately excluded: Bazaarvoice hydrates it client-side and its height is
  // set by the review count, so it is the one band whose size this script cannot reason about.
  var SEL = '[data-reveal], .pdp7 .band[id^="pdp7-"]:not(#pdp7-reviews)';
  var els = [].slice.call(document.querySelectorAll(SEL));
  if (!els.length) return;

  var vh = window.innerHeight || 800;
  var FOLD = vh * 0.92;

  if (!('IntersectionObserver' in window)) {            // failsafe: never leave content hidden
    els.forEach(function (el) { el.setAttribute('data-reveal', ''); el.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
    });
  // threshold MUST stay 0: it is a share of the ELEMENT's own area, so any non-zero value is
  // unreachable for an element taller than viewport/threshold and the reveal silently never fires.
  // The negative bottom rootMargin is what holds the "reveal just after it enters" timing.
  }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });

  els.forEach(function (el, i) {
    var top = el.getBoundingClientRect().top;
    el.setAttribute('data-reveal', '');               // activates the hide CSS for this element
    // stagger siblings that share a parent (cascade effect), capped so it never feels slow
    var prev = el.previousElementSibling;
    if (prev && prev.hasAttribute('data-reveal')) el.style.setProperty('--reveal-delay', Math.min(i % 6, 5) * 60 + 'ms');
    if (top < FOLD) el.classList.add('is-revealed');  // in/above viewport at load → show now (no flash, protects LCP)
    else io.observe(el);
  });

  // Failsafe: an observer can be attached and still never fire — see the threshold note above, and
  // any element that grows after load can outrun it. Nothing may stay hidden once it is on screen.
  var pending = els.slice();
  var queued = false;
  function sweep() {
    queued = false;
    var h = window.innerHeight || 800;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-revealed')) return false;
      if (el.getBoundingClientRect().top >= h) return true;    // genuinely still below the fold
      el.classList.add('is-revealed');
      io.unobserve(el);
      return false;
    });
    if (!pending.length) window.removeEventListener('scroll', onScroll);
  }
  function onScroll() { if (!queued) { queued = true; requestAnimationFrame(sweep); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', sweep);
})();
